module.exports = __webpack_public_path__ + "static/media/shower.0995e97f.ico";